var SwiperRessources = {
    init:function(){
        var swiper = new Swiper(".akrolab-module-ressources .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: 20,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                
                1040: {
                    spaceBetween: 45,
                }
              }
          });
    }
}

$(window).load(function(){
    if($('.akrolab-module-ressources').length){
        SwiperRessources.init();
    }
})